<script lang="ts">
    import {_} from 'svelte-i18n'
    import {activeConversations, endedNotArchivedConversations, myPendingConversations, mySession} from './services';
    import ConversationList from './ConversationList.svelte';
    import LoadingDiv from './LoadingDiv.svelte';
    import {Role} from './types';
</script>

<div style="margin: 20px 0; display: flex; flex-flow: wrap; justify-content: center;">

    {#if !$mySession.roles.includes(Role.OPERATOR) || $activeConversations.length > 0 || $myPendingConversations.length > 0}
        <div class="waiting-room-block">
            <div class="waiting-room-block-headline mdc-typography--headline4">
                {$_('chat.Waiting')}
            </div>
            {#if $myPendingConversations.length > 0}
                <ConversationList waitingConversations={$myPendingConversations} />
            {:else}
                <div>{$_('user.session.CurrentlyNotAnyWaitingClient')}</div>
            {/if}
        </div>
    {:else}
        <div class="waiting-room-block" style="display: flex; flex-direction: column; align-items: center; text-align: center;">
            <div class="waiting-room-block-headline mdc-typography--headline4">{$_('user.session.ImWaitingForClientJoining')}</div>
            <div class="mdc-typography--headline5" style="margin: 5px 0 10px 0; padding: 5px 0 10px 0">{$_('user.session.CurrentlyNotAnyWaitingClientHere')}</div>
            <LoadingDiv design="calm" />
        </div>
    {/if}

    {#if $activeConversations.length > 0}
        <div class="waiting-room-block">
            <div class="waiting-room-block-headline mdc-typography--headline4">{$_('chat.Ongoings')}</div>
            <ConversationList waitingConversations={$activeConversations} />
        </div>
    {/if}

    {#if $endedNotArchivedConversations.length > 0}
        <div class="waiting-room-block">
            <div class="waiting-room-block-headline mdc-typography--headline4">{$_('chat.Endeds')}</div>
            <ConversationList waitingConversations={$endedNotArchivedConversations} />
        </div>
    {/if}

</div>

<style lang="scss">
  .waiting-room-block {
    margin: 20px 30px;
  }
  .waiting-room-block-headline {
    margin: 5px 0;
    padding: 5px 0;
  }
</style>
